import { render, staticRenderFns } from "./MessageDeliveryChannelOptions.vue?vue&type=template&id=c8347ba0&scoped=true&"
import script from "./MessageDeliveryChannelOptions.vue?vue&type=script&lang=js&"
export * from "./MessageDeliveryChannelOptions.vue?vue&type=script&lang=js&"
import style0 from "./MessageDeliveryChannelOptions.vue?vue&type=style&index=0&id=c8347ba0&prod&scoped=true&lang=css&"
import style1 from "./MessageDeliveryChannelOptions.vue?vue&type=style&index=1&id=c8347ba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8347ba0",
  null
  
)

export default component.exports